import React, { useEffect, useState } from "react";
import { Hero } from "../components/Hero";
import { LoadingScreen } from "./LoadingScreen";
import { Quote } from "../components/Quote";
import { About } from "../components/About";
import { Cousine } from "../components/Cousine";

export const Home = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const hasLoaded = sessionStorage.getItem("homeHasLoaded");

    if (!hasLoaded) {
      // First time page load or refresh
      setIsLoading(true); // Show loading screen
      const timer = setTimeout(() => {
        setIsLoading(false); // Hide loading screen after 1 second
        sessionStorage.setItem("homeHasLoaded", "true"); // Set flag for the session
      }, 1000);

      return () => clearTimeout(timer); // Cleanup timer on unmount
    } else {
      // Skip loading screen on internal navigation
      setIsLoading(false);
    }
  }, []);

  return (
    <div>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div>
          <Hero />
          <Quote />
          <About />
          <div className="h-[.5px] bg-black/50 mx-20" />
          <Cousine />
        </div>
      )}
    </div>
  );
};
